"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const uuid = () => {
  return (++uuid.i).toString();
};
uuid.i = 0;
exports.uuid = uuid;
//# sourceMappingURL=uuid.cjs.map
